import { render, staticRenderFns } from "./board.vue?vue&type=template&id=0f2037d3&"
import script from "./board.vue?vue&type=script&lang=js&"
export * from "./board.vue?vue&type=script&lang=js&"
import style0 from "./board.vue?vue&type=style&index=0&id=0f2037d3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2037d3')) {
      api.createRecord('0f2037d3', component.options)
    } else {
      api.reload('0f2037d3', component.options)
    }
    module.hot.accept("./board.vue?vue&type=template&id=0f2037d3&", function () {
      api.rerender('0f2037d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/board/board.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/board/board.vue
// module id = D0Nd
// module chunks = 0